module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("申请人")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.staffName))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("所在部门")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.staffDeptName))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("直属领导")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.headerName))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("申请日期")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.fillDate))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "detail-page-title",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("申请信息")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("请假类别")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.leaveTypeName))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("特殊假期")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.isSpecial))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("请假时间")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.leaveTime))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("请假天数（天）")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.leaveDay))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("请假事由")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.info.leaveReason))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("工作交接说明")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.info.handoverRemark))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("外出联系方式")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.info.contactRemark))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "detail-page-title",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("考勤员核实")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("实际请假时间")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.realTime))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("实际请假天数")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.realLeaveDay))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("备注")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.info.realRemark))])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-298ff6c4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/todo/attendance/leave.vue
// module id = PbGm
// module chunks = 1